import styled from "styled-components";

export const SpanTitleLimit = styled.strong`
  font-size: 26px;
  font-weight: 300;
`;

export const InactiveBadge = styled.span`
  display: inline-block;
  box-sizing: border-box;
  width: 58px;
  height: 22px;
  margin-left: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  background: #e72237;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  text-align: center;
  vertical-align: middle;
`;

export const SmallTextLimit = styled.h4`
  font-size: 36px;
  padding-right: 1rem;
`;

export const SmallText = styled.p`
  font-size: 14px;
  padding-right: 1rem;
  font-weight: bold;
`;

export const BiggerTextLimit = styled.strong`
  font-size: 4rem;
`;

export const SpanTextLimitBold = styled.strong`
  font-size: 26px;
  font-weight: 600;
  padding-left: 1rem;
`;
